import Button from '@fieldmargin/webapp-styling/components/button';
import React from 'react';
import logo from '../images/fieldmargin-logo.svg';
import { trackLink } from '../util/Segment';
import './Header.css';
import Navigation from './navigation/Navigation';

const Header = () => (
    <header className="Header">
        <div className="wrapper HeaderWrapper">
            {/* This is an anchor rather than a Link because when going to the homepage we want
            firebase to handle any redirects for i18n. */}
            <a href="/" title="fieldmargin logo" className="HeaderLogo">
                <img src={logo} alt="fieldmargin logo" />
            </a>
            <Navigation />
            <div>
                <Button
                    as="a"
                    href="https://notes.fieldmargin.com/register"
                    title="Sign up to fieldmargin"
                    onClick={trackLink('Nav bar sign up link clicked')}
                    className="HeaderSignIn mr-4"
                    small
                >
                    Sign up
                </Button>
                <Button
                    as="a"
                    href="https://notes.fieldmargin.com/"
                    title="Login to fieldmargin"
                    variant="outline"
                    onClick={trackLink('Nav bar login link clicked')}
                    small
                >
                    Login
                </Button>
            </div>
        </div>
    </header>
);

export default Header;
